import React from 'react'

const DashboardIcon = (props) => {
    return (

        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.25998 2H16.73C17.38 2 17.96 2.02003 18.48 2.09003C21.25 2.40003 22 3.70001 22 7.26001V13.58C22 17.14 21.25 18.44 18.48 18.75C17.96 18.82 17.39 18.84 16.73 18.84H7.25998C6.60998 18.84 6.02998 18.82 5.50998 18.75C2.73998 18.44 1.98999 17.14 1.98999 13.58V7.26001C1.98999 3.70001 2.73998 2.40003 5.50998 2.09003C6.02998 2.02003 6.60998 2 7.25998 2Z" stroke="#717791" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.58 8.32007H17.2599" stroke="#717791" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.73999 14.11H6.75998H17.27" stroke="#717791" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 22H17" stroke="#717791" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.1947 8.30005H7.20368" stroke="#717791" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.4945 8.30005H10.5035" stroke="#717791" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}

export default DashboardIcon